import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import { InlineTransactions } from './ClerkTransactions';
import { toast } from 'react-toastify';

// QuickFinancialSummary removed per request

function InlineManageBookings({ onClose }) {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/bookings')
      .then(response => {
        setBookings(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching bookings:', error);
        setLoading(false);
      });
  }, []);

  const getStatusClass = (status) => {
    const statusLower = (status || '').toLowerCase();
    if (statusLower.includes('completed') || statusLower.includes('verified')) {
      return 'clerk-status-completed';
    } else if (statusLower.includes('pending')) {
      return 'clerk-status-pending';
    } else if (statusLower.includes('refunded') || statusLower.includes('cancelled')) {
      return 'clerk-status-cancelled';
    }
    return 'clerk-status-pending';
  };

  return (
    <div className="clerk-panel-card">
      <div className="clerk-panel-header">
        <div>
          <h4 className="clerk-panel-title">Manage Bookings</h4>
          <p className="clerk-panel-subtitle">View and manage all booking records</p>
        </div>
        <button className="clerk-btn-close" onClick={onClose}>✕</button>
      </div>
      {loading ? (
        <div className="clerk-loading">
          <div className="clerk-spinner"></div>
          <p>Loading bookings...</p>
        </div>
      ) : bookings.length === 0 ? (
        <div className="clerk-empty-state">
          <div className="clerk-empty-icon">📋</div>
          <p>No bookings found</p>
          <span>There are no bookings to display at this time.</span>
        </div>
      ) : (
        <div className="clerk-table-wrapper">
          <table className="clerk-table">
            <thead>
              <tr>
                <th>Booking ID</th>
                <th>Event</th>
                <th>User ID</th>
                <th>Seats</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {bookings.map((booking, idx) => (
                <tr key={booking.id} className={idx % 2 === 0 ? '' : 'clerk-table-row-alt'}>
                  <td className="clerk-table-id">#{booking.id}</td>
                  <td>Event {booking.event_id}</td>
                  <td>User {booking.user_id}</td>
                  <td>{booking.seats}</td>
                  <td className="clerk-table-amount">₹{booking.amount || 0}</td>
                  <td>
                    <span className={`clerk-status-badge ${getStatusClass(booking.payment_status)}`}>
                      {booking.payment_status || 'Pending'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function InlineIssues({ onClose }){
  const [issues, setIssues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [saving, setSaving] = useState(false);
  const maxTitle = 100;
  const maxDesc = 500;

  useEffect(()=>{ let mounted=true; api.get('/clerk/issues').then(r=>{ if (mounted){ const d = Array.isArray(r.data)? r.data : (r.data && r.data.data? r.data.data:[]); setIssues(d); } }).catch(()=>{}).finally(()=>{ if(mounted) setLoading(false); }); return ()=> mounted=false; },[]);

  async function createIssue(e){
    e.preventDefault();
    const t = title.trim();
    const d = description.trim();
    if (!t) { try{ toast.warn('Please enter a title'); }catch(_){} return; }
    if (!d) { try{ toast.warn('Please describe the issue'); }catch(_){} return; }
    setSaving(true);
    try{
      const res = await api.post('/clerk/issues',{ title: t, description: d }).catch(()=>null);
      if (res && res.data) {
        setIssues(prev => [res.data, ...prev]);
      } else {
        setIssues(prev => [{ id: Date.now(), title: t, description: d, created_at: new Date().toISOString() }, ...prev]);
      }
      setTitle('');
      setDescription('');
      try{ toast.success('Issue submitted'); }catch(_){ }
    }catch(e){
      try{ toast.error('Failed to submit issue'); }catch(_){ }
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="clerk-panel-card">
      <div className="clerk-panel-header">
        <div>
          <h4 className="clerk-panel-title">Issues</h4>
          <p className="clerk-panel-subtitle">Report and track issues</p>
        </div>
        <button className="clerk-btn-close" onClick={onClose}>✕</button>
      </div>
      <div style={{ padding: '2rem' }}>
      <form onSubmit={createIssue} style={{ marginBottom: '1.5rem', display: 'grid', gridTemplateColumns: '1fr', gap: '1rem' }}>
        <div>
          <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', color: '#475569', marginBottom: '0.5rem' }}>Title</label>
          <input
            value={title}
            onChange={e=> setTitle(e.target.value.slice(0, maxTitle))}
            placeholder="Short, descriptive title"
            style={{ width: '100%', padding: '0.75rem', border: '2px solid #e2e8f0', borderRadius: '8px', fontSize: '0.95rem', transition: 'all 0.2s' }}
            onFocus={(e) => e.target.style.borderColor = '#667eea'}
            onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
          />
          <div style={{ fontSize: '0.75rem', color: '#94a3b8', marginTop: '0.25rem' }}>{title.length}/{maxTitle}</div>
        </div>
        <div>
          <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', color: '#475569', marginBottom: '0.5rem' }}>Description</label>
          <textarea
            value={description}
            onChange={e=> setDescription(e.target.value.slice(0, maxDesc))}
            placeholder="Provide details to help resolve the issue"
            style={{ width: '100%', minHeight: '100px', padding: '0.75rem', border: '2px solid #e2e8f0', borderRadius: '8px', fontSize: '0.95rem', resize: 'vertical', transition: 'all 0.2s' }}
            onFocus={(e) => e.target.style.borderColor = '#667eea'}
            onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
          />
          <div style={{ fontSize: '0.75rem', color: '#94a3b8', marginTop: '0.25rem' }}>{description.length}/{maxDesc}</div>
        </div>
        <div style={{ display: 'flex', gap: '0.75rem' }}>
          <button 
            className={`btn btn-primary ${saving ? 'opacity-70 cursor-not-allowed' : ''}`} 
            type="submit" 
            disabled={saving}
            style={{ flex: 1 }}
          >
            {saving ? 'Submitting…' : 'Submit Issue'}
          </button>
          <button 
            type="button" 
            className="btn btn-ghost" 
            onClick={()=>{ setTitle(''); setDescription(''); }}
          >
            Reset
          </button>
        </div>
      </form>
      {loading && <div style={{ textAlign: 'center', padding: '2rem', color: '#64748b' }}>Loading issues…</div>}
      {!loading && issues.length===0 && <div style={{ textAlign: 'center', padding: '2rem', color: '#64748b' }}>No issues</div>}
      <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        {issues.map(it=> (
          <li key={it.id} style={{ 
            padding: '1rem', 
            border: '2px solid #e2e8f0', 
            borderRadius: '12px', 
            background: 'white',
            transition: 'all 0.2s',
            cursor: 'pointer'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#f8fafc';
            e.currentTarget.style.borderColor = '#cbd5e1';
            e.currentTarget.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'white';
            e.currentTarget.style.borderColor = '#e2e8f0';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
          >
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '1rem' }}>
              <div style={{ minWidth: 0, flex: 1 }}>
                <div style={{ fontWeight: '600', fontSize: '0.95rem', color: '#1e293b', marginBottom: '0.5rem' }}>#{it.id} — {it.title || it.subject || 'Issue'}</div>
                <div style={{ fontSize: '0.875rem', color: '#64748b', marginBottom: '0.5rem', lineHeight: '1.5' }}>{(it.description||'').slice(0,200)}{(it.description||'').length>200?'...':''}</div>
                <div style={{ fontSize: '0.75rem', color: '#94a3b8' }}>{it.created_at ? new Date(it.created_at).toLocaleString() : '-'}</div>
              </div>
              <button className="btn btn-sm btn-ghost" style={{ flexShrink: 0 }}>Details</button>
            </div>
          </li>
        ))}
      </ul>
      </div>
    </div>
  );
}

function InlineRefunds({ onClose }){
  const [bookings, setBookings] = useState([]);
  const [allBookings, setAllBookings] = useState([]);
  const [refundHistory, setRefundHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [refundAmount, setRefundAmount] = useState('');
  const [refundReason, setRefundReason] = useState('');
  const [processing, setProcessing] = useState(false);
  const [searchId, setSearchId] = useState('');

  useEffect(()=>{
    fetchData();
  },[]);

  useEffect(()=>{
    if (!searchId.trim()) {
      setBookings(allBookings);
      return;
    }
    const searchNum = parseInt(searchId, 10);
    if (isNaN(searchNum)) {
      setBookings([]);
      return;
    }
    setBookings(allBookings.filter(b => b.id === searchNum));
  }, [searchId, allBookings]);

  async function fetchData(){
    setLoading(true);
    try{
      const [bkRes, txRes] = await Promise.all([
        api.get('/bookings').catch(()=> ({ data: [] })),
        api.get('/clerk/transactions', { params: { limit: 100 } }).catch(()=> ({ data: [] }))
      ]);
      const all = Array.isArray(bkRes.data) ? bkRes.data : [];
      // Show bookings that can be refunded (not already refunded or cancelled)
      const eligible = all.filter(b => b.status !== 'refunded' && b.status !== 'cancelled' && b.payment_status === 'Completed');
      setAllBookings(eligible);
      setBookings(searchId ? eligible.filter(b => b.id === parseInt(searchId, 10)) : eligible);
      // Show refund transactions (negative amounts)
      const allTx = Array.isArray(txRes.data) ? txRes.data : [];
      setRefundHistory(allTx.filter(t => t.amount < 0 || t.payment_mode === 'refund').sort((a,b)=> new Date(b.created_at) - new Date(a.created_at)));
    }catch(e){}
    finally{ setLoading(false); }
  }

  async function handleRefund(){
    if (!selectedBooking) return;
    const amount = refundAmount ? parseFloat(refundAmount) : undefined;
    if (amount !== undefined && (isNaN(amount) || amount <= 0)) {
      toast.error('Invalid refund amount');
      return;
    }
    setProcessing(true);
    try{
      await api.post(`/clerk/bookings/${selectedBooking.id}/refund`, { 
        amount, 
        reason: refundReason || `Refund processed by clerk` 
      });
      toast.success(`Refund processed for booking #${selectedBooking.id}`);
      setSelectedBooking(null);
      setRefundAmount('');
      setRefundReason('');
      fetchData();
    }catch(e){
      toast.error(e.userMessage || 'Refund failed');
    }finally{
      setProcessing(false);
    }
  }

  return (
    <div className="clerk-panel-card">
      <div className="clerk-panel-header">
        <div>
          <h4 className="clerk-panel-title">Manage Refunds</h4>
          <p className="clerk-panel-subtitle">Process refunds and manage refund history</p>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <button className="btn btn-outline btn-sm" onClick={fetchData} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>🔄 Refresh</button>
          <button className="clerk-btn-close" onClick={onClose}>✕</button>
        </div>
      </div>
      <div style={{ padding: '2rem' }}>

      {loading && (
        <div className="flex items-center justify-center py-12">
          <div className="text-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-2"></div>
            <div className="text-sm text-gray-600">Loading refunds...</div>
          </div>
        </div>
      )}

      {!loading && (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Left: Bookings List */}
          <div className="lg:col-span-1">
            <div className="mb-4">
              <label className="block text-sm font-semibold text-gray-700 mb-2">Search by Booking ID</label>
              <div className="relative">
                <input 
                  type="number" 
                  className="w-full border-2 border-gray-300 p-3 rounded-lg text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition" 
                  placeholder="Enter booking ID..." 
                  value={searchId} 
                  onChange={e=>setSearchId(e.target.value)} 
                />
                {searchId && (
                  <button onClick={()=>setSearchId('')} className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600">✕</button>
                )}
              </div>
            </div>
            
            <h5 className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
              <span>📋</span> Eligible Bookings ({bookings.length})
            </h5>
            
            {bookings.length === 0 ? (
              <div className="bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
                <div className="text-4xl mb-2">📭</div>
                <div className="text-sm text-gray-600">No bookings available for refund</div>
              </div>
            ) : (
              <div className="space-y-3 max-h-[600px] overflow-y-auto pr-2">
                {bookings.map(b => (
                  <div 
                    key={b.id} 
                    className={`p-4 border-2 rounded-lg cursor-pointer transition-all duration-200 ${
                      selectedBooking?.id === b.id 
                        ? 'bg-blue-50 border-blue-500 shadow-md transform scale-[1.02]' 
                        : 'bg-white border-gray-200 hover:border-blue-300 hover:shadow-sm'
                    }`} 
                    onClick={()=>setSelectedBooking(b)}
                  >
                    <div className="flex items-start justify-between">
                      <div className="flex-1">
                        <div className="font-bold text-lg text-gray-800 mb-1">Booking #{b.id}</div>
                        <div className="grid grid-cols-2 gap-2 text-xs text-gray-600 mb-2">
                          <div><span className="font-medium">Event:</span> {b.event_id}</div>
                          <div><span className="font-medium">Seats:</span> {b.seats}</div>
                        </div>
                        <div className="flex items-center justify-between">
                          <div className="text-sm">
                            <span className="text-gray-500">Amount:</span>
                            <span className="font-bold text-green-600 ml-1">₹{b.amount || 0}</span>
                          </div>
                          <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                            b.payment_status === 'Completed' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'
                          }`}>
                            {b.status || b.payment_status}
                          </span>
                        </div>
                      </div>
                      {selectedBooking?.id === b.id && (
                        <div className="ml-2 text-blue-600 text-xl">✓</div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Middle: Refund Form */}
          <div className="lg:col-span-1">
            {selectedBooking ? (
              <div className="bg-gradient-to-br from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-lg p-5 shadow-lg">
                <div className="flex items-center gap-2 mb-4 pb-3 border-b border-blue-200">
                  <span className="text-2xl">💳</span>
                  <h5 className="font-bold text-lg text-gray-800">Process Refund</h5>
                </div>
                
                <div className="bg-white rounded-lg p-4 mb-4 border border-blue-100">
                  <div className="text-xs text-gray-500 mb-1">Booking ID</div>
                  <div className="font-bold text-xl text-gray-800">#{selectedBooking.id}</div>
                </div>

                <div className="bg-white rounded-lg p-4 mb-4 border border-blue-100">
                  <div className="text-xs text-gray-500 mb-1">Original Amount</div>
                  <div className="font-bold text-2xl text-green-600">₹{selectedBooking.amount || 0}</div>
                </div>

                <div className="mb-4">
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Refund Amount <span className="text-gray-400 font-normal">(leave blank for full refund)</span>
                  </label>
                  <input 
                    type="number" 
                    step="0.01"
                    max={selectedBooking.amount || 0}
                    className="w-full border-2 border-gray-300 p-3 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition" 
                    placeholder={`Max: ₹${selectedBooking.amount || 0}`} 
                    value={refundAmount} 
                    onChange={e=>setRefundAmount(e.target.value)} 
                  />
                  {refundAmount && parseFloat(refundAmount) > (selectedBooking.amount || 0) && (
                    <div className="text-red-600 text-xs mt-1">⚠ Amount exceeds original booking amount</div>
                  )}
                </div>

                <div className="mb-4">
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Reason <span className="text-gray-400 font-normal">(optional)</span>
                  </label>
                  <textarea 
                    className="w-full border-2 border-gray-300 p-3 rounded-lg text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition resize-none" 
                    rows="3" 
                    placeholder="Enter refund reason..." 
                    value={refundReason} 
                    onChange={e=>setRefundReason(e.target.value)} 
                  />
                </div>

                <div className="flex gap-2">
                  <button 
                    className="flex-1 btn btn-primary py-3 font-semibold shadow-md hover:shadow-lg transition" 
                    onClick={handleRefund} 
                    disabled={processing || (refundAmount && parseFloat(refundAmount) > (selectedBooking.amount || 0))}
                  >
                    {processing ? (
                      <span className="flex items-center justify-center gap-2">
                        <span className="animate-spin">⏳</span> Processing...
                      </span>
                    ) : (
                      <span className="flex items-center justify-center gap-2">
                        ✓ Approve & Process
                      </span>
                    )}
                  </button>
                  <button 
                    className="btn btn-ghost py-3 font-semibold" 
                    onClick={()=>{ setSelectedBooking(null); setRefundAmount(''); setRefundReason(''); }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            ) : (
              <div className="bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg p-12 text-center h-full flex items-center justify-center">
                <div>
                  <div className="text-5xl mb-4">👆</div>
                  <div className="text-gray-600 font-medium">Select a booking to process refund</div>
                  <div className="text-sm text-gray-500 mt-2">Click on any booking from the list</div>
                </div>
              </div>
            )}
          </div>

          {/* Right: Refund History */}
          <div className="lg:col-span-1">
            <h5 className="font-semibold text-gray-800 mb-4 flex items-center gap-2">
              <span>📜</span> Refund History
            </h5>
            
            {refundHistory.length === 0 ? (
              <div className="bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
                <div className="text-4xl mb-2">📋</div>
                <div className="text-sm text-gray-600">No refunds processed yet</div>
              </div>
            ) : (
              <div className="space-y-3 max-h-[600px] overflow-y-auto pr-2">
                {refundHistory.slice(0, 15).map(t => (
                  <div key={t.id} className="bg-white border-2 border-gray-200 rounded-lg p-4 hover:border-red-300 hover:shadow-md transition">
                    <div className="flex items-start justify-between mb-2">
                      <div className="font-bold text-gray-800">Booking #{t.booking_id}</div>
                      <span className="px-2 py-1 bg-red-100 text-red-700 rounded-full text-xs font-semibold">REFUND</span>
                    </div>
                    <div className="flex items-center justify-between">
                      <div>
                        <div className="text-xs text-gray-500 mb-1">Refund Amount</div>
                        <div className="font-bold text-lg text-red-600">₹{Math.abs(t.amount)}</div>
                      </div>
                      <div className="text-right">
                        <div className="text-xs text-gray-500 mb-1">Date</div>
                        <div className="text-xs text-gray-700 font-medium">
                          {t.created_at ? new Date(t.created_at).toLocaleDateString() : '-'}
                        </div>
                        <div className="text-xs text-gray-500">
                          {t.created_at ? new Date(t.created_at).toLocaleTimeString() : '-'}
                        </div>
                      </div>
                    </div>
                    {t.notes && (
                      <div className="mt-2 pt-2 border-t border-gray-200">
                        <div className="text-xs text-gray-500">Note: {t.notes}</div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
      </div>
    </div>
  );
}

function InlineVipBooking({ onClose }){
  const [events, setEvents] = useState([]);
  const [eventId, setEventId] = useState('');
  const [seatCount, setSeatCount] = useState(1);
  const [customerName, setCustomerName] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [amount, setAmount] = useState(0);

  useEffect(()=>{ api.get('/events').then(r=> setEvents(Array.isArray(r.data)? r.data:[])).catch(()=> setEvents([])); },[]);

  useEffect(()=>{
    async function compute(){
      const cnt = Math.max(1, parseInt(seatCount,10)||1);
      if (!eventId){ setAmount(0); return; }
      // Fetch unit price from bookings table for this event
      try{
        const r = await api.get(`/bookings/event-price/${eventId}`).catch(()=>null);
        const unit = r && r.data && typeof r.data.price !== 'undefined' ? Number(r.data.price) : 0;
        setAmount(cnt * unit);
      }catch(_){ setAmount(0); }
    }
    compute();
  },[eventId, seatCount]);

  async function handleCreate(e){
    e.preventDefault(); setError(null);
    const count = Math.max(1, parseInt(seatCount,10)||1);
    if (!eventId) return setError('Select an event');
    setSaving(true);
    try{
      const res = await api.post('/clerk/bookings/vip', { eventId, seats: count, vipName: customerName });
      const bookingId = res?.data?.id;
      toast.success(`VIP booking created${bookingId? ' (#'+bookingId+')':''}`);
      setEventId(''); setSeatCount(1); setCustomerName('');
    }catch(err){ setError(err.userMessage || 'Failed to create VIP booking'); }
    finally{ setSaving(false); }
  }

  return (
    <div className="clerk-panel-card">
      <div className="clerk-panel-header">
        <div>
          <h4 className="clerk-panel-title">Make Booking (VIP)</h4>
          <p className="clerk-panel-subtitle">Create VIP bookings for special customers</p>
        </div>
        <button className="clerk-btn-close" onClick={onClose}>✕</button>
      </div>
      <div style={{ padding: '2rem' }}>
      <form onSubmit={handleCreate} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
        <div>
          <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', color: '#475569', marginBottom: '0.5rem' }}>Event</label>
          <select 
            style={{ width: '100%', padding: '0.75rem', border: '2px solid #e2e8f0', borderRadius: '8px', fontSize: '0.95rem', transition: 'all 0.2s' }}
            value={eventId} 
            onChange={e=>setEventId(e.target.value)}
            onFocus={(e) => e.target.style.borderColor = '#667eea'}
            onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
          >
            <option value="">Select event</option>
            {events.map(ev=> <option key={ev.id} value={ev.id}>{ev.name} — {ev.date}</option>)}
          </select>
        </div>
        <div>
          <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', color: '#475569', marginBottom: '0.5rem' }}>Seats</label>
          <input 
            type="number" 
            min="1" 
            style={{ width: '100%', padding: '0.75rem', border: '2px solid #e2e8f0', borderRadius: '8px', fontSize: '0.95rem', transition: 'all 0.2s' }}
            value={seatCount} 
            onChange={e=>setSeatCount(e.target.value)}
            onFocus={(e) => e.target.style.borderColor = '#667eea'}
            onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
          />
        </div>
        <div>
          <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', color: '#475569', marginBottom: '0.5rem' }}>Customer (optional)</label>
          <input 
            style={{ width: '100%', padding: '0.75rem', border: '2px solid #e2e8f0', borderRadius: '8px', fontSize: '0.95rem', transition: 'all 0.2s' }}
            value={customerName} 
            onChange={e=>setCustomerName(e.target.value)} 
            placeholder="VIP name"
            onFocus={(e) => e.target.style.borderColor = '#667eea'}
            onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
          />
        </div>
        <div style={{ gridColumn: '1 / -1', padding: '1rem', background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)', borderRadius: '12px', border: '2px solid #e2e8f0' }}>
          <span style={{ fontSize: '0.95rem', color: '#475569', fontWeight: '600' }}>Amount: </span>
          <span style={{ fontSize: '1.25rem', color: '#059669', fontWeight: '700' }}>₹{amount}</span>
        </div>
        {error && <div style={{ gridColumn: '1 / -1', padding: '0.75rem', background: '#fef2f2', border: '2px solid #fecaca', borderRadius: '8px', color: '#dc2626', fontSize: '0.875rem' }}>{error}</div>}
        <div style={{ gridColumn: '1 / -1', display: 'flex', gap: '0.75rem' }}>
          <button 
            className={`btn btn-primary ${saving ? 'opacity-70 cursor-not-allowed':''}`} 
            type="submit" 
            disabled={saving}
            style={{ flex: 1 }}
          >
            {saving? 'Creating…':'Create VIP Booking'}
          </button>
          <button 
            type="button" 
            className="btn btn-ghost" 
            onClick={()=>{ setEventId(''); setSeatCount(1); setCustomerName(''); }}
          >
            Reset
          </button>
        </div>
      </form>
      </div>
    </div>
  );
}

export default function DashboardClerk(){
  const { user } = useAuth();
  const [activeQuick, setActiveQuick] = useState('bookings');

  return (
    <div className="clerk-dashboard-container">
      <header className="clerk-dashboard-header">
        <div>
          <h1 className="clerk-dashboard-title">{user?.role === 'Clerk' ? 'Clerk Dashboard' : 'Dashboard'}</h1>
          <p className="clerk-dashboard-subtitle">Quick actions for clerks are below.</p>
        </div>
      </header>

      {user?.role === 'Clerk' ? (
        <div className="clerk-content-wrapper">
          <div className="clerk-quick-actions-card">
            <h3 className="clerk-section-title">Quick Actions</h3>
            <div className="clerk-actions-grid">
              <button 
                className={`clerk-action-btn ${activeQuick === 'bookings' ? 'clerk-action-btn-active' : ''}`}
                onClick={()=> setActiveQuick(a => a === 'bookings' ? null : 'bookings')}
              >
                <span className="clerk-action-icon">📅</span>
                <span>Manage Bookings</span>
              </button>
              <button 
                className={`clerk-action-btn ${activeQuick === 'transactions' ? 'clerk-action-btn-active' : ''}`}
                onClick={()=> setActiveQuick(a => a === 'transactions' ? null : 'transactions')}
              >
                <span className="clerk-action-icon">💳</span>
                <span>Transactions</span>
              </button>
              <button 
                className={`clerk-action-btn ${activeQuick === 'refunds' ? 'clerk-action-btn-active' : ''}`}
                onClick={()=> setActiveQuick(a => a === 'refunds' ? null : 'refunds')}
              >
                <span className="clerk-action-icon">💰</span>
                <span>Manage Refunds</span>
              </button>
              <button 
                className={`clerk-action-btn ${activeQuick === 'issues' ? 'clerk-action-btn-active' : ''}`}
                onClick={()=> setActiveQuick(a => a === 'issues' ? null : 'issues')}
              >
                <span className="clerk-action-icon">⚠️</span>
                <span>Issues</span>
              </button>
              <button 
                className={`clerk-action-btn ${activeQuick === 'vip' ? 'clerk-action-btn-active' : ''}`}
                onClick={()=> setActiveQuick(a => a === 'vip' ? null : 'vip')}
              >
                <span className="clerk-action-icon">👑</span>
                <span>Make Booking (VIP)</span>
              </button>
            </div>
          </div>

          {activeQuick === 'bookings' && <InlineManageBookings onClose={()=>setActiveQuick(null)} />}
          {activeQuick === 'transactions' && <InlineTransactions onClose={()=>setActiveQuick(null)} />}
          {activeQuick === 'refunds' && <InlineRefunds onClose={()=>setActiveQuick(null)} />}
          {activeQuick === 'issues' && <InlineIssues onClose={()=>setActiveQuick(null)} />}
          {activeQuick === 'vip' && <InlineVipBooking onClose={()=>setActiveQuick(null)} />}

          {/* Quick Financial Summary removed */}
        </div>
      ) : (
        <div className="grid grid-cols-3 gap-4">
          <div className="p-4 bg-white rounded shadow">Card 1</div>
          <div className="p-4 bg-white rounded shadow">Card 2</div>
          <div className="p-4 bg-white rounded shadow">Card 3</div>
        </div>
      )}
    </div>
  );
}
